"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _travelHeading = _interopRequireDefault(require("../travel-heading"));

var _block = _interopRequireDefault(require("./block"));

var _partner = _interopRequireDefault(require("./images/partner-1.png"));

var _partner2 = _interopRequireDefault(require("./images/partner-2.png"));

var _partner3 = _interopRequireDefault(require("./images/partner-3.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TravelPartner = function TravelPartner(props) {
  var site = props.site;
  var socialBusiness = (site === null || site === void 0 ? void 0 : site.socialMediaLinks) || {};
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "partner index-section"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react["default"].createElement(_travelHeading["default"], {
    heading: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "we would love to hear from you!")
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "partner__list"
  }, /*#__PURE__*/_react["default"].createElement(_block["default"], {
    name: "yelp",
    img: _partner["default"],
    url: socialBusiness['yelp-business'] || '#'
  }), /*#__PURE__*/_react["default"].createElement(_block["default"], {
    name: "google-business",
    img: _partner2["default"],
    url: socialBusiness['google-business'] || '#'
  }), /*#__PURE__*/_react["default"].createElement(_block["default"], {
    name: "facebook-business",
    img: _partner3["default"],
    url: socialBusiness['facebook-business'] || '#'
  }))));
};

var _default = TravelPartner;
exports["default"] = _default;